/* Progressive enhancement: details, links and the Shopify form work without JS. */
if (!customElements.get('spadea-partnerships')) {
  customElements.define('spadea-partnerships', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-partnership-interest]');
        if (!link || !this.contains(link)) return;
        const select = this.querySelector('[data-interest-select]');
        if (select) {
          select.value = link.dataset.partnershipInterest;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const block = [...this.querySelectorAll('[data-partnership-block]')].find(item => item.dataset.partnershipBlock === event.detail?.blockId);
        if (block) block.open = true;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
